import { render, staticRenderFns } from "./AvailablePaymentChannel.vue?vue&type=template&id=ef8e4eaa&scoped=true"
import script from "./AvailablePaymentChannel.vue?vue&type=script&lang=js"
export * from "./AvailablePaymentChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8e4eaa",
  null
  
)

export default component.exports